import { QueryParams } from '../constants/QueryParams';

export const getReturnToCurrentUrlFromLogin = (): {
  encodedCurrentUrl: string;
  currentUrl: string;
} => {
  const url = new URL(window.location.href);
  url.searchParams.set(QueryParams.RETURNED_FROM_LOGIN_PAGE, 'true');
  return {
    encodedCurrentUrl: encodeURIComponent(url.href),
    currentUrl: url.href,
  };
};
